import React from 'react';
import { UserInfoItem, BOOL, RemoteStream, WeMeetClient, UserItem } from '@tencent/wemeet-websdk-next';

import { useAppSelector, useAppDispatch } from '@store/hooks';
import { updateBigVideo, getBigVideoData } from '@store/studio/studio.slice';

import { VideoPrefix } from '@constant/media';

import Avatar from '@component/avatar';
import MicState from '@component/mic-state';
import PhoneState from '@component/phone-state';
import VideoPlay from '@component/video-play/VideoPlay';

import HostIcon from '@asset/image/user/icon_host.svg';
import CoHostIcon from '@asset/image/user/icon_co_host.svg';
import ScreenIcon1x from '@asset/image/user/member_sharing(1).png';
import ScreenIcon2x from '@asset/image/user/member_sharing(1)@2x.png';

import './SmallVideoBlock.scss';
import { useAudioLevel } from '@utils/hooks/useAudioLevel';
import { hasScreen, hasStream, isUserAudioOn, isUserVideoOn } from '@utils/helper/media';
import { useTranslation } from 'react-i18next';

interface SmallVideoBlockProps {
  user: UserInfoItem;
}
const SmallVideoBlock: React.FC<SmallVideoBlockProps> = (props) => {
  const { user } = props;
  const { t } = useTranslation();

  const bigVideoData = useAppSelector(getBigVideoData);
  const dispatch = useAppDispatch();
  const audioLevel = useAudioLevel(user?.rtcStream?.stream, false);

  /**
   * 点击小画面
   *
   * 大画面展示点击的小画面
   * 1. TODO: 跳过处理？如当前大画面就是当前的小画面？
   * @param item
   */
  const onSmallVideoClick = (item: UserInfoItem) => {
    // 远端流的屏幕共享的 hasVideo 也是 true
    // TODO: 需要测试本地的屏幕共享
    if (item.rtcStream?.stream?.hasVideo()) {
      dispatch(updateBigVideo(item));
    }
  };

  return (
    <div
      className={`small-video-block ${audioLevel > 0 && isUserAudioOn(user) ? 'small-video-block--saying' : ''}`}
      key={user?.id?.['@app_uid']}
      onClick={() => onSmallVideoClick(user)}
    >
      {/* TODO 视频摄像头开启或者是屏幕共享才展示下方视屏 */}
      {(isUserVideoOn(user) && hasStream(user)) || hasScreen(user) ? (
        <VideoPlay
          stream={user?.rtcStream?.stream as RemoteStream}
          className={`small-video-block__video ${user?.isSelf ? 'self-video' : ''}`}
          isLocal={user?.rtcStream?.isLocal ?? false}
          prefix={VideoPrefix.small}
          streamType={user?.rtcStream?.streamType}
          videoId={user?.rtcStream?.videoId ?? ''}
          userId={user.id as UserItem}
          cameraOn={isUserVideoOn(user)}
          isSwitchSmall={
            bigVideoData?.id?.['@app_uid'] !== user?.id?.['@app_uid'] && user?.rtcStream?.isLocal === false
          }
        />
      ) : (
        <div className="small-video-block__avatar">
          <Avatar
            avatarType={user?.avatar_type}
            mode="middle"
            nickname={user?.nickname}
            avatarToken={user?.avatar_token ?? ''}
            userDistrict={user?.user_district}
          />
        </div>
      )}

      <div className="small-video-block__user">
        {WeMeetClient.utils.isHost(user) && <img src={HostIcon} alt="" className="icon-host" />}
        {WeMeetClient.utils.isCoHost(user) && <img src={CoHostIcon} alt="" className="icon-co-host" />}
        {hasScreen(user) && !user?.isPhoneUser && <img srcSet={`${ScreenIcon1x}  1x,${ScreenIcon2x} 2x`} alt="" />}
        {user?.isPhoneUser && !hasScreen(user) && (
          <PhoneState
            mode="small"
            on={user?.up_audio_on?.__value === BOOL.true}
            ableOuterLevel
            outerLevel={audioLevel}
          />
        )}
        {!user?.isPhoneUser && !hasScreen(user) && (
          <MicState
            mode="small"
            micOn={user?.up_audio_on?.__value === BOOL.true}
            stream={user?.rtcStream?.stream}
            ableOuterLevel
            outerLevel={audioLevel}
          />
        )}
        <span className="small-video-block__user__nickname">
          {user?.nickname}
          {hasScreen(user) ? t('的屏幕') : ''}
        </span>
      </div>
    </div>
  );
};

export default SmallVideoBlock;
